import { useSelector } from 'react-redux';

import * as IssuesV2Store from '../../../redux/issuesV2';
import { selectOptionFactory } from '../../../utils';
import { FilterPanel, MultiSelectFilter } from '../../generic/Filter';
import useFetchIssuesAction from '../IssuesInbox/hooks/useFetchIssuesAction';
import useOrgLabels from '../IssuesInbox/hooks/useOrgLabels';
import type { MultiSelectFilterOption } from '../../generic/Filter/MultiSelectFilter';

/**
 * Add a multi-select dropdown menu for filtering issues by project labels.
 */
const ProjectLabelsFilter = () => {
  const { isLoading, labels } = useOrgLabels();
  const isDisabled = labels.length === 0;

  const projectLabelsFilter = useSelector(IssuesV2Store.selectors.getProjectLabelsFilter);
  const setProjectLabelsFilter = useFetchIssuesAction(IssuesV2Store.actions.setProjectLabelsFilter);

  // convert project labels between the simple string[] type (used in the redux store)
  // and the MultiSelectFilterOption[] type used by the multi-select component
  const selectedProjectLabels = projectLabelsFilter.map((label) => selectOptionFactory(label, label));
  const setSelectedProjectLabels = (selected: MultiSelectFilterOption[]) => {
    setProjectLabelsFilter(selected.map((option) => option.value));
  };

  return (
    <FilterPanel>
      <MultiSelectFilter
        title="Project Labels"
        placeholder={isLoading ? 'Loading...' : 'Select one or more...'}
        values={selectedProjectLabels}
        options={labels}
        isDisabled={isDisabled}
        testId="issues-project-labels-filter"
        onChange={setSelectedProjectLabels}
      />
    </FilterPanel>
  );
};

export default ProjectLabelsFilter;
